import { Directive, Output, HostBinding, HostListener, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appDragDrop]'
})
export class DragDropDirective {

  @Output() onFileDropped = new EventEmitter<any>();

  @HostBinding('style.background-color') private background = '#bb86fc26';
  @HostBinding('style.opacity') private opacity = '1';

  
  //Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: Event) {
    this.setStyling('#bb86fc', '0.5',evt);
  }
  //Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt:Event) {
    this.setStyling('#bb86fc26', '1',evt);
  }
  //Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt:any) {
    this.setStyling('#bb86fc26', '1',evt);
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileDropped.emit(files);
    }
  }

  setStyling(background:string, opacity:string, evt:Event): void{
    evt.preventDefault();
    evt.stopPropagation();
    this.background = background;
    this.opacity = opacity;
  }

}
